import React from 'react';

import { ReactComponent as LeftArrow } from 'assets/icons/simple-dates/back-arrow.svg';

import { BaseButton, ButtonTypes } from 'components/base/BaseButton';

import css from './header.module.sass';

type Props = {
  totalSteps: number;
  currentStep: number;
  onBackBtnClick: () => void;
};

export const Header: React.FC<Props> = ({
  totalSteps,
  currentStep,
  onBackBtnClick,
}) => {
  return (
    <div className={css.root}>
      <div className={css.wrapper}>
        {currentStep > 0 && (
          <BaseButton
            type={ButtonTypes.Transparent}
            className={css.backBtn}
            onClick={onBackBtnClick}
          >
            <LeftArrow />
          </BaseButton>
        )}
        {!!totalSteps && (
          <p className={css.status}>
            {currentStep + 1}/{totalSteps}
          </p>
        )}
      </div>
      <div className={css.progressTruck}>
        <div
          className={css.progressThumb}
          style={{ width: `${(currentStep / totalSteps) * 100}%` }}
        />
      </div>
    </div>
  );
};
